/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from 'react'
import { Link } from "react-router-dom";

const Footer: React.FC = () => {

  return (
    <>
      <div className="d-flex mt-0 pt-0 pb-0 footer-style">
        <div className="col-lg-5">
          <p className="text-end small-font mt-3">
            {new Date().getFullYear()} &copy; Frayo. All Rights Reserved.
          </p>
        </div>   <div className="flex-grow-1 d-flex align-items-center justify-content-center" style={{ minWidth: 0 }}>
          <img src="/assets/images/icons8-visa-card.svg" alt="Visa" style={{ height: 32, marginRight: 8 }} />
          <img src="/assets/images/icons8-mastercard.svg" alt="Mastercard" style={{ height: 32, marginRight: 8 }} />
          <img src="/assets/images/icons8-american-express.svg" alt="American Express" style={{ height: 32 }} />
        </div>
        <div className="col-lg-5">
          <p className="text-center small-font mt-3">
            <span className="text-end mx-5">
              <Link
                to="/terms-conditions"
                className="footer-link cursorPointer me-3"
              >
                Terms & Conditions
              </Link>{" "}
              <Link
                to="/privacy-policy"
                className="footer-link cursorPointer me-3"
              >
                Privacy Policy
              </Link>{" "}
              <Link to="/refund-policy" className="footer-link cursorPointer">
                Refund Policy
              </Link>{" "}
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
